import React, { useRef, useState, useEffect } from 'react'
import { useReactToPrint } from 'react-to-print';
import Form from 'react-bootstrap/Form';
import axios from '../../../interceptor/axios-config';
import { Modal} from 'react-bootstrap';
import { useTCSData } from '../../../context/TcsContext';
import './printStyles.css';  // Import the external CSS
import IndividualTaslTable from './IndividualTaslTable';

const PedagogicTasks = () => {

    let slno=1;

    // for print 
    const componentRef = useRef();
    const [taskModal, setTaskModoal] = useState(false);

    const { subjectAssignment, loadingSD, refetchSCData } = useTCSData();
        
    // Individual Teacher's Task
    const [tTasks, setTTasks] = useState(null);

      // transformation
    const inputArray = subjectAssignment;      
    const outputArray = [];    
    const teacherMap = new Map();
    
    // console.log(inputArray);

    if (inputArray.length > 0) {
        inputArray.forEach(item => {
          const { empcode, taskId, teacher, alloted_section, task, task_code, assigned_on, updated_on } = item;
      
          // Check if the empcode exists in the map
          if (!teacherMap.has(empcode)) {
            // Initialize with task_count starting at 1
            teacherMap.set(empcode, { empcode, ttaList: [], task_count: 1 });
          } else {
            // Get the teacher's record from the map
            const teachers = teacherMap.get(empcode);
      
            // Add the new task to the ttaList
            teachers.ttaList.push({ taskId, teacher, task_code, task, alloted_section, assigned_on, updated_on });
      
            // Increment the task_count
            teachers.task_count += 1;
          }
      
          // If it's the first task, add the task to ttaList as well
          if (!teacherMap.get(empcode).ttaList.length) {
            const teachers = teacherMap.get(empcode);
            teachers.ttaList.push({ taskId, teacher, task_code, task, alloted_section, assigned_on, updated_on });
          }
        });
      }
      
      // Push the teachers to the output array
      teacherMap.forEach(teacher => {
        outputArray.push(teacher);
      });
      // console.log(outputArray);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleView = (empcode) =>{
        const iTasks = outputArray.filter(person => person.empcode === empcode);
        setTTasks(iTasks);
        setTaskModoal(true)
    }

    console.log(tTasks);

    return (
        <>
            <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">PT</h5>
                                <div className='d-flex'>
                                    {/* <Form.Select size="sm" style={{width:'120px'}} value={sclass} onChange={selectClassFuntion}> */}
                                    <Form.Select size="sm" style={{width:'120px'}}>
                                        <option>--Select--</option>
                                        {/* {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)} */}
                                    </Form.Select>
                                    <span className="p-1"></span>  
                                    {/* <button type="button" className="btn btn-primary" onClick={() => childRef.current.openModal()}> */}
                                    <button type="button" className="btn btn-primary" onClick={handlePrint}>
                                        Print PT
                                    </button>
                                    <span className="p-1"></span>  
                                    {/* <button type="button" className="btn btn-primary" onClick={() => childRef.current.openModal()}> */}
                                    <button type="button" className="btn btn-primary" onClick={refetchSCData}>
                                        Refresh
                                    </button>
                                </div>
                            </div>
                            
                            <div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                                    <div className="table-responsive full-data">
                                        <div id="example-teacher_wrapper" className="dataTables_wrapper no-footer">
                                            <table className="table-responsive-lg table table-striped" id="example-teacher">
                                                <thead>
                                                    <tr> 
                                                        <th className='bg-danger'>Teacher</th>
                                                        <th className='bg-danger'>EMP CODE</th>
                                                        <th className='bg-danger'>Pedagogic Tasks( Subject-Code-Section)</th>
                                                        <th className='bg-danger'>Task Count</th>
                                                        <th className='bg-danger'>Actions</th>
                                                    </tr>                
                                                </thead>
                                                {loadingSD 
                                                    ? (<p>Loading...</p>) 
                                                    :(<tbody>
                                                        {outputArray.map((item, index) => 
                                                        <tr key={index}>
                                                        <td>
                                                            <div className="trans-list">
                                                                    <h4>{item.ttaList[0].teacher}</h4>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {item.empcode}
                                                        </td>
                                                        <td className='table-success'>
                                                            {item.ttaList.map(subj =>
                                                                <ul>
                                                                    <li>{subj.task} - {subj.task_code} - Class: {subj.alloted_section}</li>
                                                                </ul>
                                                            )}
                                                      </td>
                                                      <td className='bg-warning'>
                                                        <h5>{item.task_count}</h5>
                                                      </td>
                                                        
                                                        <td>
                                                            <div className="d-flex">
                                                                <div className="icon-box icon-box-sm bg-light me-2" onClick={()=>handleView(item.empcode)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-440q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320H280Zm80-80h400q0-33 23.5-56.5T840-480v-160q-33 0-56.5-23.5T760-720H360q0 33-23.5 56.5T280-640v160q33 0 56.5 23.5T360-400Zm440 240H120q-33 0-56.5-23.5T40-240v-440h80v440h680v80ZM280-400v-320 320Z"/></svg>
                                                                </div>
                                                                <div className="icon-box icon-box-sm bg-light me-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-280h240v-80H240v80Zm120-160h240v-80H360v80Zm120-160h240v-80H480v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        </tr>
                                                        )}                                                    
                                                    </tbody>)}
                                            </table>    
                                            <div className="d-sm-flex text-center justify-content-between align-items-center">                           
                                                
                                                <div
                                                    className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                    id="example-teacher_wrapper"
                                                >
                                                </div>
                                            </div>   
                                        </div>
                                    </div>  
                                </div> 
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* actual content for printing  */}
                <div ref={componentRef} className="print-only">
                {/* <table className="table-responsive-lg table table-striped" id="example-teacher" > */}
                <table className="print-table" id="example-teacher" >
                    <thead>
                        <tr> 
                            <th className='bg-primary text-white'>Teacher</th>
                            <th className='bg-primary text-white'>EMP CODE</th>
                            <th className='bg-primary text-white'>Pedagogic Tasks( Subject-Code-Section)</th>
                            <th className='bg-primary text-white'>Task Count</th>
                        </tr>                
                    </thead>
                    {loadingSD 
                        ? (<p>Loading...</p>) 
                        :(<tbody>
                            {outputArray.map((item, index) => 
                            <tr key={index}>
                            <td>
                                <div>
                                        <h4>{item.ttaList[0].teacher}</h4>
                                </div>
                            </td>
                            <td>
                                <h5 className='text-dark'>{item.empcode}</h5>
                            </td>
                            <td>
                                {item.ttaList.map(subj =>
                                    <ul>
                                        <li>
                                            <h5 className='text-dark'>
                                                {subj.task} - {subj.task_code} - Class: {subj.alloted_section}
                                            </h5>
                                        </li>
                                    </ul>
                                )}
                            </td>
                            <td>
                            <h5>{item.task_count}</h5>
                            </td>
                            </tr>
                            )}                                                    
                        </tbody>)}
                </table> 
            </div>
            {/* Modals  */}
            <Modal className="modal fade"size='xl'  show={taskModal} onHide={setTaskModoal} centered>              
                <form >
                    <div className="modal-header">
                        <h4 className="modal-title fs-20">Edit Task</h4>
                        <button type="button" className="btn-close" onClick={()=> setTaskModoal(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="add-contact-box">
                            <div className="add-contact-content">                               
                               { tTasks !== null
                                ?<IndividualTaslTable data={tTasks} />
                                :'No tasks'
                               } 
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">Print</button>  
                        <button type="button" onClick={()=> {}} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>      
                    </div>
                </form>  
            </Modal>
        </>
    )
}

export default PedagogicTasks
